import React, { Fragment, PureComponent } from "react";
import styled, { css, keyframes } from "styled-components";

export const fadeIn = offset => keyframes`
  from {
    transform: translateY(${offset}px) rotate(${offset}deg);
    opacity: 0;
  }

  to {
    transform: translateY(0px);
    opacity: 1;
  }
`;

export const AnimatedLetter = styled.span`
  animation: ${props => fadeIn(props.offset)} ${props => props.duration}s
    forwards;
  display: inline-block;
  opacity: 0;
`;

export class RandomDelayedLetter extends PureComponent {
  render() {
    return (
      <AnimatedLetter
        duration={(Math.random() * 2).toPrecision(2)}
        {...this.props}
        offset={Math.random() <= 0.5 ? 75 : -200}
      />
    );
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Transitions.js